import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import {
  BackupHealthStatus,
  FailbackStatus,
  RecoveryEnvironmentStatus,
} from 'src/app/account/components/application/statusText'

/**
 * The `.tab-status-bar` replica shared by the Recovery, Backup and Tab Status
 * showcases. Styling comes from the global `.tab-status-bar` rules in styles.scss.
 *
 * The class lives on the host rather than an inner div so the bar stays a real
 * sibling of the operation-status notice the Recovery preview renders after it —
 * an inner wrapper would break the `+ .operation-status-notice` adjacency that
 * drops the bottom padding (rule in the showcase-shared mixin).
 */
@Component({
  selector: 'showcase-status-bar',
  templateUrl: './showcase-status-bar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  host: {
    '[class]': 'hostClasses',
    'aria-live': 'polite',
  },
})
export class ShowcaseStatusBarComponent {
  // priorBackupInfo is Backup-only, so the template reads it through $any().
  @Input({ required: true }) status!: BackupHealthStatus | RecoveryEnvironmentStatus | FailbackStatus

  get hostClasses(): string {
    return `tab-status-bar ${this.status?.state ?? ''}`
  }
}
